import { StandardLocalWidget, nothing } from 'widgets-for-react'
import { BlockData } from '../../../cms/blocks/types.gen'
import { CustomBlock } from '../../../drupal/types_and_parser/custom_blocks.mod'
import { Block } from '../../../drupal/types_and_parser/standard_blocks.gen'
import { CMSState } from '../../drupalPage/state'
import { carrouselBlock, carrouselBlockProps, carrouselBlockStyle } from './widgets/carrouselBlock'
import { ctaBlock, ctaBlockProps, ctaBlockStyle } from './widgets/ctaBlock.mod'
import { customSpacerBlock, customSpacerBlockProps, customSpacerBlockStyle } from './widgets/customSpacerBlock.mod'
import { expandBlock, expandBlockProps, expandBlockStyle } from './widgets/expandBlock.mod'
import {
  factsAndFiguresBlock,
  factsAndFiguresBlockProps,
  factsAndFiguresBlockStyle
} from './widgets/factsAndFiguresBlock.mod'
import { formBlock, formBlockProps, formBlockStyle } from './widgets/formBlock'
import { GridHighlightBlock, GridHighlightBlockProps, GridHighlightBlockStyle } from './widgets/gridHighlightBlock'
import { HubSpotFrameBlockStyle, HubspotIFrameProps, hubspotIFrameBlock } from './widgets/hubspotIFrame'
import { ImageWithExpandablesBlock, ImageWithExpandablesBlockProps, ImageWithExpandablesBlockStyle } from './widgets/imageWithExpandablesBlock'
import { latestUpdatesBlock, latestUpdatesBlockProps, latestUpdatesBlockStyle } from './widgets/latestUpdatesBlock.mod'
import { MediaBlockStyle, mediaBlock, mediaBlockProps } from './widgets/mediaBlock.mod'
import { personBlock, personBlockProps, personBlockStyle } from './widgets/personBlock.mod'
import { pressReleasesBlock, pressReleasesBlockProps, pressReleasesBlockStyle } from './widgets/pressReleasesBlock'
import { QuoteBlockStyle, quoteBlock, quoteBlockProps } from './widgets/quoteBlock.mod'
import { quotesBlock, quotesBlockProps, quotesBlockStyle } from './widgets/quotesBlock.mod'
import { reportsBlock, reportsBlockProps, reportsBlockStyle } from './widgets/reportsBlock.mod'
import { storiesBlock, storiesBlockProps, storiesBlockStyle } from './widgets/storiesBlock.mod'
import { textBlock, textBlockProps, textBlockStyle } from './widgets/textBlock.mod'
import { textImageBlock, textImageBlockProps, textImageBlockStyle } from './widgets/textImageBlock.mod'
import { timelineBlock, timelineBlockProps, timelineBlockStyle } from './widgets/timelineBlock.mod'
import { cardsBlock, CardsBlockProps, cardsBlockStyle } from './widgets/cardsBlock.mod'
//add here your custom blocks definitions

export type CustomBlockData =
  | personBlock
  | carrouselBlock
  | quoteData
  | formBlockData
  | hubspotIFrameData
  | mediaBlockData
  | storiesBlockData
  | timelineBlockData
  | textImageBlockData
  | textBlockData
  | pressReleasesBlockData
  | expandBlockData
  | reportsBlockData
  | ctaBlockData
  | quotesBlockData
  | latestUpdatesBlockData
  | customSpacerBlockData
  | factsAndFiguresBlockData
  | gridHighlightBlockData
  | imageWithExpandablesBlockData
  | cardsBlockData

export function isCustomBlockData(b: BlockData | CustomBlockData): b is CustomBlockData {
  return (
    b.kind == 'personBlock' ||
    b.kind == 'carrouselBlock' ||
    b.kind == 'formBlock' ||
    b.kind == 'quoteBlock' ||
    b.kind == 'pressReleasesBlock' ||
    b.kind == 'hubspotIFrameBlock' ||
    b.kind == 'mediaBlock' ||
    b.kind == 'storiesBlock' ||
    b.kind == 'timelineBlock' ||
    b.kind == 'textBlock' ||
    b.kind == 'textImageBlock' ||
    b.kind == 'expandBlock' ||
    b.kind == 'reportsBlock' ||
    b.kind == 'ctaBlock' ||
    b.kind == 'quotesBlock' ||
    b.kind == 'latestUpdatesBlock' ||
    b.kind == 'customSpacerBlock' ||
    b.kind == 'factsAndFiguresBlock' ||
    b.kind == 'gridHighlightBlock' ||
    b.kind == 'imageWithExpandablesBlock' ||
    b.kind == 'cardsBlock'
  )
}

export function isCustomBlock(b: Block | CustomBlock): b is CustomBlock {
  return (
    b.kind == 'personBlock' ||
    b.kind == 'grid_blocks_image' ||
    b.kind == 'grid_blocks_plain' ||
    b.kind == 'iframe' ||
    b.kind == 'quote' ||
    b.kind == 'text_with_image' ||
    b.kind == 'form' ||
    b.kind == 'reports_overview' ||
    b.kind == 'cta' ||
    b.kind == 'quotes' ||
    b.kind == 'latest_updates_block' ||
    b.kind == 'custom_spacer' ||
    b.kind == 'facts_and_figures' ||
    b.kind == 'grid_highlight' ||
    b.kind == 'image_with_expandable' ||
    b.kind == 'cards'
  )
}

export const renderCustomBlock =
  (block: CustomBlockData): StandardLocalWidget<CMSState> =>
  (s0) => {
    if (block.kind == 'personBlock') {
      return personBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'quoteBlock') {
      return quoteBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'pressReleasesBlock') {
      return pressReleasesBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'mediaBlock') {
      return mediaBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'storiesBlock') {
      return storiesBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'textImageBlock') {
      return textImageBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'textBlock') {
      return textBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'timelineBlock') {
      return timelineBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'carrouselBlock') {
      return carrouselBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'customSpacerBlock') {
      return customSpacerBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'formBlock') {
      return formBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'hubspotIFrameBlock') {
      return hubspotIFrameBlock(block.value[0], { style: block.value[1] })
    } else if (block.kind == 'expandBlock') {
      return expandBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'reportsBlock') {
      return reportsBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'ctaBlock') {
      return ctaBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'quotesBlock') {
      return quotesBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'latestUpdatesBlock') {
      return latestUpdatesBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'gridHighlightBlock') {
      return GridHighlightBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'factsAndFiguresBlock') {
      return factsAndFiguresBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'imageWithExpandablesBlock') {
      return ImageWithExpandablesBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'cardsBlock') {
      return cardsBlock(block.value[0], { style: block.value[1] })(s0)
    } else {
      return nothing()
    }
  }

export type personBlock = { kind: 'personBlock'; value: [personBlockProps, personBlockStyle] }
export type carrouselBlock = { kind: 'carrouselBlock'; value: [carrouselBlockProps, carrouselBlockStyle] }
export type quoteData = { kind: 'quoteBlock'; value: [quoteBlockProps, QuoteBlockStyle] }
export type hubspotIFrameData = { kind: 'hubspotIFrameBlock'; value: [HubspotIFrameProps, HubSpotFrameBlockStyle] }
export type formBlockData = { kind: 'formBlock'; value: [formBlockProps, formBlockStyle] }
export type mediaBlockData = { kind: 'mediaBlock'; value: [mediaBlockProps, MediaBlockStyle] }
export type storiesBlockData = { kind: 'storiesBlock'; value: [storiesBlockProps, storiesBlockStyle] }
export type timelineBlockData = { kind: 'timelineBlock'; value: [timelineBlockProps, timelineBlockStyle] }
export type textImageBlockData = { kind: 'textImageBlock'; value: [textImageBlockProps, textImageBlockStyle] }
export type textBlockData = { kind: 'textBlock'; value: [textBlockProps, textBlockStyle] }
export type pressReleasesBlockData = {
  kind: 'pressReleasesBlock'
  value: [pressReleasesBlockProps, pressReleasesBlockStyle]
}
export type expandBlockData = { kind: 'expandBlock'; value: [expandBlockProps, expandBlockStyle] }
export type reportsBlockData = { kind: 'reportsBlock'; value: [reportsBlockProps, reportsBlockStyle] }
export type ctaBlockData = { kind: 'ctaBlock'; value: [ctaBlockProps, ctaBlockStyle] }
export type quotesBlockData = { kind: 'quotesBlock'; value: [quotesBlockProps, quotesBlockStyle] }
export type latestUpdatesBlockData = {
  kind: 'latestUpdatesBlock'
  value: [latestUpdatesBlockProps, latestUpdatesBlockStyle]
}
export type customSpacerBlockData = {
  kind: 'customSpacerBlock'
  value: [customSpacerBlockProps, customSpacerBlockStyle]
}
export type factsAndFiguresBlockData = {
  kind: 'factsAndFiguresBlock'
  value: [factsAndFiguresBlockProps, factsAndFiguresBlockStyle]
}
export type gridHighlightBlockData = {
  kind: 'gridHighlightBlock'
  value: [GridHighlightBlockProps, GridHighlightBlockStyle]
}
export type imageWithExpandablesBlockData = {
  kind: 'imageWithExpandablesBlock'
  value: [ImageWithExpandablesBlockProps, ImageWithExpandablesBlockStyle]
}
export type cardsBlockData = {
  kind: 'cardsBlock'
  value: [CardsBlockProps, cardsBlockStyle]
}
